// toast.service.ts
import { Injectable, signal } from '@angular/core';

export type ToastKind = 'success' | 'info' | 'warning' | 'error';

export interface Toast {
    id: number;
    kind: ToastKind;
    title?: string;
    message: string;
    timeoutMs?: number; // default 6s
}

@Injectable({ providedIn: 'root' })
export class ToastService {
    private _toasts = signal<Toast[]>([]);
    toasts = this._toasts.asReadonly();

    private nextId = 1;

    show(toast: Omit<Toast, 'id'>) {
        const t: Toast = { id: this.nextId++, timeoutMs: 6000, ...toast };
        this._toasts.update(arr => [t, ...arr]);
        if (t.timeoutMs && t.timeoutMs > 0) {
            window.setTimeout(() => this.dismiss(t.id), t.timeoutMs);
        }
    }

    dismiss(id: number) {
        this._toasts.update(arr => arr.filter(t => t.id !== id));
    }

    // Convenience helpers
    error(message: string, title = 'Error', timeoutMs = 6000) {
        this.show({ kind: 'error', title, message, timeoutMs });
    }
    success(message: string, title = 'Success', timeoutMs = 4000) {
        this.show({ kind: 'success', title, message, timeoutMs });
    }
    info(message: string, title = 'Info', timeoutMs = 5000) {
        this.show({ kind: 'info', title, message, timeoutMs });
    }
    warning(message: string, title = 'Warning', timeoutMs = 6000) {
        this.show({ kind: 'warning', title, message, timeoutMs });
    }
}
